import { Box } from '@mui/material';
import { FC, ReactNode } from 'react';
import { FeatureLayout } from '@lendica/components';

import { ScrollToTabs } from './components/ScrollToTabs';
// import { useWalletDataContext } from './WalletData';
import { useWalletElementContext } from './views/WalletView';
import { useCompanyContext } from '@lendica/hooks';

export const WalletContainer: FC<{ children: ReactNode }> = ({ children }) => {
    const { containerRef, walletRef, myDealsRef } = useWalletElementContext();
    const { membershipsLoading, isCompanyResolved } = useCompanyContext();

    return (
        <FeatureLayout loading={membershipsLoading || !isCompanyResolved}>
            <Box
                sx={{
                    bgcolor: 'background.paper',
                    position: 'sticky',
                    top: 0,
                    zIndex: 0,
                    px: 4,
                    pt: 1,
                }}
            >
                <ScrollToTabs
                    labels={['Wallet', 'Deals']}
                    containerRef={containerRef}
                    toRefs={[walletRef, myDealsRef]}
                />
            </Box>
            <Box
                ref={containerRef}
                sx={{
                    overflowY: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative',
                    height: '100%',
                    px: 4,
                }}
            >
                {children}
            </Box>
        </FeatureLayout>
    );
};
